import PageHeader from "../components/PageHeader";
import Contact from "../components/Contact";
import { contact } from "../data/content";

export default function ContactPage() {
  return (
    <>
      <PageHeader
        eyebrow={contact.eyebrow}
        title={contact.heading}
        lead={contact.intro}
      />
      <Contact headless />
    </>
  );
}
